import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FontLab } from "../dev/FontLab";
import { AskEqva } from "../ask/AskEqva";
import { WayFinder } from "./WayFinder";
import { HeaderThemeContext } from "./HeaderTheme";
import { get } from "../../lib/api";
import { absUrl, t } from "../../lib/i18n";

export default function Layout() {
  const [settings, setSettings] = useState({});
  const [dark, setDark] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => { get("/settings").then(setSettings).catch(() => {}); }, []);

  // hreflang + canonical: every page exists in both languages at the same path (/ and /en)
  useEffect(() => {
    const links = [["alternate", "nb", absUrl(pathname, "no")], ["alternate", "en", absUrl(pathname, "en")], ["alternate", "x-default", absUrl(pathname, "no")]];
    const els = links.map(([rel, lang, href]) => { const l = document.createElement("link"); l.rel = rel; l.hreflang = lang; l.href = href; l.dataset.i18n = "1"; return l; });
    document.querySelectorAll("link[data-i18n]").forEach((l) => l.remove());
    els.forEach((l) => document.head.appendChild(l));
  }, [pathname]);

  // Scroll to top on navigation – or to the #anchor once it has rendered (and again after late layout shifts).
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    let tries = 0;
    const timers = [];
    const id = decodeURIComponent(hash.slice(1));
    const t = setInterval(() => {
      const el = document.getElementById(id);
      if (el) {
        clearInterval(t);
        el.scrollIntoView({ block: "start" });
        let last = window.scrollY;
        [450, 1100, 2000].forEach((ms) => timers.push(setTimeout(() => {
          if (Math.abs(window.scrollY - last) > 4) return; // user has scrolled – leave them be
          el.scrollIntoView({ block: "start" });
          last = window.scrollY;
        }, ms)));
      } else if (++tries > 40) clearInterval(t);
    }, 75);
    return () => { clearInterval(t); timers.forEach(clearTimeout); };
  }, [pathname, hash]);

  return (
    <HeaderThemeContext.Provider value={{ dark, setDark }}>
      <div className="flex min-h-screen flex-col">
        <a href="#innhold" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:px-4 focus:py-2">{t("Hopp til innhold")}</a>
        <Header />
        <main id="innhold" className="flex-1">
          <Outlet context={{ settings }} />
        </main>
        <Footer settings={settings} />

        <AskEqva />
        <WayFinder />
        <FontLab />
        <Toaster
          position="bottom-left"
          toastOptions={{
            unstyled: true,
            classNames: {
              toast: "flex w-[min(92vw,420px)] items-start gap-3 bg-navy px-5 py-4 text-white text-[15px] leading-snug",
              title: "font-semibold",
              description: "text-white/75 mt-1",
            },
          }}
        />
      </div>
    </HeaderThemeContext.Provider>
  );
}
